var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:[`${_vm.$appPrefix}-icon`, _vm.sizeClass, _vm.animationClass],attrs:{"xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){return _vm.handleClick($event)}}},[_c('use',{attrs:{"xlink:href":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }